import { useSearchParams } from 'react-router-dom'

export const useLocationSource = (): string | undefined => {
  const [searchParams] = useSearchParams()
  const sourceParameter = searchParams.get('source')

  return sourceParameter ? decodeURIComponent(sourceParameter) : undefined
}
